module.exports = __webpack_public_path__ + "img/website-mock-statistics.c3c56859.png";